import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import AnimatedLayout from 'components/layouts/animated-layout';
import { BulletStatus } from 'components/bullet-status/bullet-status';

const WaitingStep: React.FC = (): JSX.Element => {
    return (
        <AnimatedLayout>
            <Box
                sx={{
                    maxWidth: 860,
                    mx: 'auto',
                    py: { xs: 0.25, sm: 0.5 },
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        justifyContent: 'space-between',
                        gap: 1.25,
                        flexWrap: 'wrap',
                        pb: 1.5,
                        mb: 1.5,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box
                            sx={(theme) => ({
                                width: 42,
                                height: 42,
                                flexShrink: 0,
                                borderRadius: 1.25,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'warning.main',
                                backgroundColor: alpha(
                                    theme.palette.warning.main,
                                    theme.palette.mode === 'dark' ? 0.12 : 0.08,
                                ),
                                border: '1px solid',
                                borderColor: alpha(theme.palette.warning.main, 0.18),
                                '& i': { fontSize: 18 },
                            })}>
                            <i className="fa-light fa-hourglass-clock" />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: 'YekanBalkhHeavy',
                                    fontSize: 15,
                                    color: 'text.primary',
                                }}>
                                وضعیت مدارک
                            </Typography>
                            <Typography
                                sx={{
                                    mt: 0.15,
                                    fontSize: 10.75,
                                    color: 'text.secondary',
                                }}>
                                آخرین وضعیت بررسی مدارک احراز هویت شما
                            </Typography>
                        </Box>
                    </Box>

                    <BulletStatus
                        type="warning"
                        label="در انتظار بررسی"
                    />
                </Box>

                <Typography
                    sx={{
                        fontSize: 12.25,
                        lineHeight: 2.05,
                        color: 'text.primary',
                    }}>
                    کاربر گرامی،{' '}
                    <Box component="span" sx={{ fontFamily: 'YekanBalkhHeavy' }}>
                        مدارک شما منتظر تایید است.
                    </Box>{' '}
                    اطلاعات ارسالی توسط کارشناسان واحد احراز هویت بررسی شده و نتیجه
                    آن از طریق پیامک به اطلاع شما خواهد رسید. لطفاً تا زمان بررسی و
                    اعلام نتیجه شکیبا باشید.
                </Typography>

                <Box
                    sx={(theme) => ({
                        mt: 1.5,
                        p: { xs: 1.25, sm: 1.5 },
                        borderRadius: 1.25,
                        border: '1px solid',
                        borderColor: theme.palette.divider,
                        backgroundColor:
                            theme.palette.mode === 'dark'
                                ? alpha(theme.palette.common.white, 0.02)
                                : alpha(theme.palette.primary.main, 0.018),
                    })}>
                    <Typography
                        sx={{
                            fontSize: 11.5,
                            lineHeight: 2,
                            color: 'text.secondary',
                        }}>
                        هرگونه تغییر در وضعیت احراز هویت به صورت خودکار در این صفحه
                        بروزرسانی شده و همچنین از طریق پیامک و ایمیل اطلاع‌رسانی
                        می‌گردد.
                    </Typography>
                </Box>

                <Box
                    sx={(theme) => ({
                        mt: 1.5,
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 0.85,
                        p: { xs: 1.25, sm: 1.5 },
                        borderRadius: 1.25,
                        color:
                            theme.palette.mode === 'dark'
                                ? theme.palette.success.light
                                : theme.palette.success.dark,
                        backgroundColor: alpha(
                            theme.palette.success.main,
                            theme.palette.mode === 'dark' ? 0.09 : 0.055,
                        ),
                        border: '1px solid',
                        borderColor: alpha(theme.palette.success.main, 0.2),
                    })}>
                    <i
                        className="fa-light fa-circle-check"
                        style={{ marginTop: 4 }}
                    />
                    <Typography
                        sx={{
                            fontSize: 11.75,
                            lineHeight: 1.95,
                            fontFamily: 'YekanBalkhHeavy',
                            color: 'inherit',
                        }}>
                        پس از تایید مدارک می‌توانید از بخش درگاه پرداخت اقدام به ایجاد
                        درگاه پرداخت کنید.
                    </Typography>
                </Box>
            </Box>
        </AnimatedLayout>
    );
};

export default WaitingStep;
